// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-main-title {
    font-family: "Karla" !important;
    font-weight: 400 !important;
    font-size: 16px !important;
}

.stock-sub-title {
    font-family: "Karla" !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    line-height: 19.51px !important;
    letter-spacing: -0.36px !important;
}

.stock-table-header, .stock-table-data {
    font-family: "Karla" !important;
    font-weight: 400 !important;
    font-size: 18px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/StockInfoModal/StockInfoModalstyle.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,0BAA0B;IAC1B,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,0BAA0B;AAC9B","sourcesContent":[".stock-main-title {\n    font-family: \"Karla\" !important;\n    font-weight: 400 !important;\n    font-size: 16px !important;\n}\n\n.stock-sub-title {\n    font-family: \"Karla\" !important;\n    font-weight: 700 !important;\n    font-size: 15px !important;\n    line-height: 19.51px !important;\n    letter-spacing: -0.36px !important;\n}\n\n.stock-table-header, .stock-table-data {\n    font-family: \"Karla\" !important;\n    font-weight: 400 !important;\n    font-size: 18px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
